// German dictionary.
// Empty for now — keys not present here fall back automatically to the English
// dictionary in I18nProvider. Add German translations as they become available.
const de: Record<string, string> = {};
export default de;
